import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Ceil, Min, Scale } from "@pdfking/math"
import { MM } from "@pdfking/quantity"

import type { CalendarArea } from "#internal"

import { Slice } from "../layout/Slice"
import { Area } from "./Area"

// The gap between months, the share of its place a month's grid takes across,
// and its title's against its rows
const GAP = MM(1)
const WIDTH = 0.88
const TITLE = 1.25

/** The year's months `first` to `last` packed `columns` across `box` as a
 * pocket calendar's templates set them: unruled, their days large in their
 * cells, the weekdays' initials, no days of the months either side, each its
 * name over it. */
export const PocketMonths = (
  box: SpatialRectangle<Distance>,
  year: number,
  columns: number,
  first = 1,
  last = 12
): CalendarArea[] => {
  const rows = Ceil((last - first + 1) / columns)
  // Each month's place, as Area.months splits the box
  const [place] = Slice.grid(box, columns, rows, GAP, 1)
  const width = Scale(place!.width, WIDTH / 7)
  const height = Scale(place!.height, 1 / (7 + TITLE))
  return Area.months(box, year, columns, GAP, first, last, {
    font: Min(Scale(height, 0.8), Scale(width, 0.68)),
    height,
    initials: true,
    muted: false,
    rules: false,
    title: "month",
    title_scale: TITLE,
    width,
  })
}
